import React, { FunctionComponent, useState, useRef, useEffect } from 'react';
import { makeStyles, Box, Tooltip, Fab, Grid } from '@material-ui/core';
import { AutoSizer } from 'react-virtualized';
import BackToTopArrow from '@material-ui/icons/ArrowUpward';
import { Skeleton } from '@material-ui/lab';
import InfiniteScroll from 'react-infinite-scroll-component';

type HistoryListViewProps = {
    className?: string;
    dataLength: number;
    hasMore: boolean;
    loadMore: Function;
    classes?: any;
    loading: boolean;
};
const useStyles = makeStyles({
    root: {
        '&>.infinite-scroll-component__outerdiv': {
            height: '100%',
            overflow: 'hidden',
        },
    },
    fab: {
        position: 'absolute',
        bottom: 75,
        right: 40,
    },
});
const HistoryLoader: FunctionComponent = () => (
    <Grid container style={{ paddingLeft: 20 }}>
        <Grid item sm={5} md={8} lg={10}>
            <Skeleton />
        </Grid>
        <Grid item sm={3} md={5} lg={8}>
            <Skeleton />
            <Skeleton />
        </Grid>
    </Grid>
);

const HistoryListView: FunctionComponent<HistoryListViewProps> = (props) => {
    const { dataLength, hasMore, loadMore, loading } = props;
    const [showBackToTop, setShowBackToTop] = useState<boolean>(false);

    const classes = useStyles();
    const ref = useRef<any>(null);

    useEffect(() => {
        const scrollRef = ref.current;
        if (scrollRef) {
            scrollRef.addEventListener('scroll', handleScroll);
        }
        return () => {
            scrollRef.removeEventListener('scroll', handleScroll);
        };
    });

    const scrollToTop = () => {
        ref.current.scrollTo({ top: 0, behavior: 'smooth' }); //scroll to the top of the table
    };
    const handleScroll = (event: any) => {
        if (event?.target?.scrollTop > 200 && !showBackToTop) {
            setShowBackToTop(true);
        } else if (event?.target?.scrollTop === 0) {
            setShowBackToTop(false);
        }
    };
    return (
        <AutoSizer disableWidth className="fullWidth">
            {({ height }) => (
                <Box style={{ height }} className={classes.root}>
                    <InfiniteScroll
                        dataLength={dataLength}
                        hasMore={hasMore}
                        next={() => loadMore()}
                        loader={<HistoryLoader />}
                        onScroll={(e) => handleScroll(e)}
                        scrollableTarget={'historyNode'}
                    >
                        <div
                            id="historyNode"
                            style={{
                                height: 0.85 * height,
                                overflow: 'auto',
                                width: '100%',
                                paddingBottom: 50,
                            }}
                            ref={ref}
                        >
                            {props.children}
                            {loading && <HistoryLoader />}
                        </div>
                        {showBackToTop && (
                            <Tooltip title="Back to Top" placement="top">
                                <Fab
                                    size="small"
                                    className={classes.fab}
                                    aria-label="Back to Top"
                                    onClick={scrollToTop}
                                >
                                    <BackToTopArrow color="primary" />
                                </Fab>
                            </Tooltip>
                        )}
                    </InfiniteScroll>
                </Box>
            )}
        </AutoSizer>
    );
};

export default HistoryListView;
